module.exports = __webpack_public_path__ + "img/sbl-zfb.7689bc76.png";